export default "__VITE_ASSET__BM6oOl3I__ 374w";